import { randomBytes } from "crypto";
import forge from "node-forge";


export class DkimGenerator {

  static generateDkimKeyPair(): {base64PrivateKey: string, publicKey: string} {
    const keypair = forge.pki.rsa.generateKeyPair(2048);
    const privateKey = forge.pki.privateKeyToPem(keypair.privateKey);
    const publicKey = forge.pki.publicKeyToPem(keypair.publicKey);

    // Convert private key to base64 format
    const base64PrivateKey = privateKey
      .replace('-----BEGIN RSA PRIVATE KEY-----', '')
      .replace('-----END RSA PRIVATE KEY-----', '')
      .replace(/\r?\n|\r/g, '')


    return {base64PrivateKey, publicKey};
  }

  static createSelector(): string {
    // Generate a random hex string of a specific length, e.g., 16 characters
    return `ns${randomBytes(8).toString('hex')}`;
  }

  static formatPublicKeyForDns(publicKey: string): string {
    return publicKey
      .replace('-----BEGIN PUBLIC KEY-----', '')
      .replace('-----END PUBLIC KEY-----', '')
      .replace(/\n/g, '')
      .replace(/\r/g, '');

  }

  static formatTXTRecord(pubKey: string): string{
    return `p=${pubKey}`
  }
}
